<template>
    <va-create-layout>
        <CouponPaymentEventFee-form
            :title="title"
            :item="item"
        ></CouponPaymentEventFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
